import { SvgIcon, SvgIconProps } from '@mui/material'

const CheckIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
  </SvgIcon>
)

export default CheckIcon
